module.exports = __webpack_public_path__ + "Lato-Light.7244318390cc4d36aac4.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Light.woff2
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Light.woff2
// module chunks = styles